import { RichTextWithDraft } from './RichTextWithDraft';

export default RichTextWithDraft;
